import styled from "@mui/material/styles/styled";
import Container from "@mui/material/Container";

export const SectionBox = styled(Container, { shouldForwardProp: (props) => props !== "bgColor" })(
  ({ theme, bgColor }) => ({
    padding: "1.5rem",
    background: bgColor || theme.palette.info.contrastText,
    borderRadius: 8,
    // border: `1px solid ${theme.palette.paste[50]}`,
    // boxShadow: "0px 1px 6px 0px #00000008",
    // maxWidth: bgColor !== "inherit" ? "calc(100% - 3rem)" : "100%",
    // "@media only screen and (min-width: 1280px)": {
    //   maxWidth: bgColor !== "inherit" ? "calc(1280px - 3rem)" : "1280px",
    // },
  }),
);
